import { r as e, h as t } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const s = ".sc-bold-icon-h{display:flex}", i = s, r = class {
  constructor(o) {
    e(this, o), this.width = "15", this.height = "15";
  }
  render() {
    return t("svg", { key: "ead5efde091bb403800ddc1a842b5d34021d3d95", width: this.width, height: this.height, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, t("path", { key: "59e022b66f14d32eec1c10747b3ada397532910c", d: "M6 4V20M9.5 4H15.5C17.7091 4 19.5 5.79086 19.5 8C19.5 10.2091 17.7091 12 15.5 12H9.5H16.5C18.7091 12 20.5 13.7909 20.5 16C20.5 18.2091 18.7091 20 16.5 20H9.5M9.5 4V20M9.5 4H4M9.5 20H4", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }));
  }
};
r.style = i;
export {
  r as bold_icon
};
